import MdaeScrollView from "./component";
import { IScrollViewOptions } from "devextreme-react/scroll-view";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeScrollViewProps extends IScrollViewOptions {
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaeScrollView;
